module.exports = __webpack_public_path__ + "img/unsub-logo.c43f4555.png";